import CropAndSaveImageRequest from "@/api/dataSource/api/Spirit/Common/FileManager/Models/CropAndSaveImageRequest";
import AppSettings from "@/appSettings";
import ImagePreviewModel from "crop-image/src/ImagePreviewModel";

function isDataUrl(value: string): boolean {
    return value.indexOf('data:') === 0;
}

function getInlineImagePath(value: string): string {
    const mimeMatch = value.match(/^data:([^;]+);base64,/i);
    const mimeType = ((mimeMatch || [])[1] || '').toLowerCase();

    switch (mimeType) {
        case 'image/png':
            return 'upload.png';
        case 'image/gif':
            return 'upload.gif';
        case 'image/jpeg':
        case 'image/jpg':
        default:
            return 'upload.jpg';
    }
}

function normalizeImagePath(value: string): string {
    const trimmedValue = (value || '').trim();
    if (!trimmedValue || isDataUrl(trimmedValue)) {
        return trimmedValue;
    }

    const filesBaseUrl = AppSettings.filesBaseUrl.replace(/\/+$/, '');
    if (trimmedValue.indexOf(`${filesBaseUrl}/`) === 0) {
        return trimmedValue.slice(filesBaseUrl.length);
    }

    return trimmedValue;
}

export function mapToCropRequest(img: ImagePreviewModel): CropAndSaveImageRequest {
    if (!img || (!img.ImageUrl && !img.Width && !img.Height)) {
        return null;
    }
    const imageUrl = (img.ImageUrl || '').trim();
    if (!imageUrl || imageUrl === '/assets/img/no_image.svg') {
        return null;
    }

    const inlineUpload = isDataUrl(imageUrl);

    return new CropAndSaveImageRequest({
        ImgBase: inlineUpload ? imageUrl : null,
        Path: inlineUpload ? getInlineImagePath(imageUrl) : normalizeImagePath(imageUrl),
        Height: parseInt((img.Height || 0).toString()),
        Left: parseInt((img.Left || 0).toString()),
        Top: parseInt((img.Top || 0).toString()),
        Width: parseInt((img.Width || 0).toString()),
        MaxWidth: null,
        MaxHeight: null
    });
}
